import type { LeadCompleteness } from '@viq-admin/types';

export interface NotesCounterState {
  have: number;
  need: number;
  /** Omitted for a sent lead: sent leads are never flagged (spec 2026-09-14 §1.4). */
  tone?: 'success' | 'danger';
}

/**
 * The lead detail "{have} / {need}" notes counter (spec 2026-09-14 §3.4): red
 * below the company's notes minimum, green at or above it. Hidden (undefined)
 * when the company's rules are off, it has no notes minimum, or the backend
 * predates lead rules. A sent lead keeps the numbers but loses the colour.
 */
export function notesCounterState(lead: {
  completeness?: LeadCompleteness | null;
  crmSentAt?: string | null;
}): NotesCounterState | undefined {
  const notes = lead.completeness?.notes;
  if (!notes) return undefined;
  if (lead.crmSentAt) return { have: notes.have, need: notes.need };
  return { have: notes.have, need: notes.need, tone: notes.have >= notes.need ? 'success' : 'danger' };
}
